import styled from "styled-components";
import { 
  Form as AntForm, 
  Typography as AntTypography,
  Input as AntInput,
  Button as AntButton,
  Divider as AntDivider,
} from "antd";
import { BackArrow } from '@assets';
import { AuthBg } from "@assets/auth";
import lightTheme from '@styles/theme';

export const RootContainer = styled.div`
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: column;
  background-image: url(${AuthBg});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  padding: 0px 16px;

  .ant-form-item-explain {
    text-align: left; /* align warning text to the left */
    margin-left: 24px;
  }

  .ant-btn-primary {
    width: 100%;
    height: 52px;
    border-radius: 27px !important;
  }

  #login-btn {
    margin-bottom: 30px;
  }
`;

export const NavContainer = styled.div`
  display: flex;
  width: 100%;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-top: 16px;
`;

export const ArrowIconWrapper = styled.div`
  width: 50px;
  height: 50px;
  background-color: ${lightTheme.appbarColor};
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 7px;
  cursor: pointer;
`
export const BackIcon = styled(BackArrow)`
  width: 15px;
  height: 11px;
`;

export const SkipButton = styled(AntButton)`
  background-color: #FFFFFF;
  border: none;
  text-align: center;
  width: 91px;
  height: 35px;
  float: right;
  margin: 0 9px 0 0;
  border-radius: 30px;
  color: #C21C05 !important;
  font-family: Plus Jakarta Sans;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
`

export const ContentContainer = styled.div`
  width: 100%;
  margin: 259px auto 24px;

  @media (max-height: 700px) {
    margin-top: 200px !important;
  }
`

export const Title = styled(AntTypography.Title)`
  color: #FFF !important;
  text-align: center;
  font-size: 24px !important;
  font-style: normal;
  font-weight: 700 !important;
  line-height: normal !important;
` 

export const Form = styled(AntForm)`
  margin-top: 30px;
  width: 100%;
  text-align: center;

  .ant-form-item {
    margin-bottom: 32px;
  }

  .ant-form-item:last-child {
    margin-bottom: 0 !important;
  }

  .ant-form-item-label {
    margin-left: 24px;
    text-align: left;
    padding: 0 !important;
  }

  .ant-form-item-label label {
    color: #E1A59C;
    font-size: 14px;
    font-family: Plus Jakarta Sans;
    font-style: normal;
    font-weight: 400;
  }

  .ant-input-affix-wrapper {
    height: 52px;
    border: 1px solid #e1cce0;
    border-radius: 10px;

    input {
      height: auto !important;
      text-align: center;
    }
  }

  input {
    height: 52px;
    border: 1px solid #e1cce0;
    border-radius: 10px;
    text-align: center;
  }

  .ant-btn-primary {
    margin-top: 8px;
  }
`;

export const Input = styled(AntInput)`
  -moz-appearance: textfield;
;

  &::placeholder {
    font-size: 16px;
    font-family: Plus Jakarta Sans;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    color: #7E8485; 
  }
  appearance: textfield;
  ::-webkit-inner-spin-button,
  ::-webkit-outer-spin-button {
    -webkit-appearance: none; /* WebKit */
    margin: 0;
  }
  ::-webkit-inner-spin-button:disabled,
  ::-webkit-outer-spin-button:disabled {
    display: none;
  }
  && {
    border-radius: 34px;
    text-align: left;
    padding-left: 24px;
    color: #181E1F;
    font-size: 16px;
    font-family: Plus Jakarta Sans;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }
`;

export const BottomText = styled.div`
  font-size: 14px;
  font-weight: normal;
  color: #ffffff;
  margin-bottom: 30px;
`;

export const Link = styled.span`
  font-size: 14px;
  font-weight: bold;
  color: ${(props) => props.theme.primaryColor};
  cursor: pointer;
`;

export const Divider = styled(AntDivider)`
  margin: 24px auto !important;
  padding: 0 52px;
  
  .ant-divider-horizonta{
    min-width: 254px;
  }

  .ant-divider-inner-text {
    box-sizing: border-box;
    color: #fff;
    font-size: 14px;
    font-family: Poppins;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
    background: #342309;
    width: fit-content !important; /* Set the desired width */
    height: 28px !important;
    border-radius: 50%;
    text-align: center !important; /* Optional, to center the text horizontally */
    padding: 3px 7px;
    margin-left: 24px;
    margin-right: 24px;
  }

  ::before,
  ::after {
    border: 1px solid #e1cce0;
    border-color: #FFD260 !important;
  }
`;

export const GoToPromoRegisterButton = styled(AntButton)`
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  color: black;
  background-color: #F5D016 !important;
  &:hover {
    background-color: #F5D016 !important;
    color: black !important;
  }
`

export const GoogleLoginButton = styled.div`
margin-top: 24px;
margin-bottom: 24px;
width: 100%;
height: 52px;
border-radius: 34px;
display: flex;
gap: 10px;
align-items: center;
justify-content: center;
background-color: #fff;
cursor: pointer;
position: relative;

font-size: 14px;
font-weight: bold;

svg {
  width: 24px;
}

.ant-spin {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
`;

export const SpaceBetweenTopBottom = styled.div`
margin-top: 24px;
margin-bottom: 24px;
width:100%;
`;

export const SocialRegisterWrapper = styled.div`
display:flex;
width:100%;
gap:20px;
align-items:center
`;

export const TelegramRegisterButton = styled.div`
margin-top: 24px;
margin-bottom: 24px;
width: 100%;
height: 52px;
border-radius: 34px;
display: flex;
gap: 10px;
align-items: center;
justify-content: center;
background-color: #fff;
cursor: pointer;
position: relative;

font-size: 14px;
font-weight: bold;

svg {
  width: 24px;
}

.ant-spin {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
`;